module.exports = __webpack_public_path__ + "img/H000140_apple.9bc5753a.png";